"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3018],{

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ applyFnToProps; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Applies a function to properties of a specified type in an object, recursively.
 *
 * @param {Object} obj - The object to apply the function to.
 * @param {Function} fn - The function to apply to matching properties.
 * @param {string} [type='string'] - The type of properties to apply the function to.
 * @param {Array<string>} [ignoreKeys=[]] - The keys of properties to ignore and not modify.
 * @returns {Object} - The object with function recursively applied.
 */
function applyFnToProps(obj, fn, type = 'string', ignoreKeys = []) {
  if (!obj || typeof obj !== 'object') return obj;
  Object.keys(obj).forEach(property => {
    if (typeof obj[property] === 'object') {
      applyFnToProps(obj[property], fn, type, ignoreKeys);
    } else {
      // eslint-disable-next-line valid-typeof
      if (typeof obj[property] === type && !ignoreKeys.includes(property)) obj[property] = fn(obj[property]);
    }
  });
  return obj;
}

/***/ }),

/***/ 9267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aggregate": function() { return /* binding */ Aggregate; }
});

// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/register-handler.js
var register_handler = __webpack_require__(5992);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/console.js
var console = __webpack_require__(1639);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/stringify.js
var stringify = __webpack_require__(4155);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/aggregate-base.js + 7 modules
var aggregate_base = __webpack_require__(7410);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/logging/constants.js
var constants = __webpack_require__(5146);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/runtime.js
var runtime = __webpack_require__(9152);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/clean-url.js
var clean_url = __webpack_require__(1478);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/logging/shared/log.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



class Log {
  /** @type {long} the unix timestamp of the log event */
  timestamp;
  /** @type {string} the log message */
  message;
  /** @type {object} the object of attributes to be parsed by logging ingest into top-level properties */
  attributes;
  /** @type {'ERROR'|'TRACE'|'DEBUG'|'INFO'|'WARN'} the log type of the log */
  level;

  /**
   * @param {number} timestamp - Unix timestamp
   * @param {string} message - message string
   * @param {object} attributes - other log event attributes
   * @param {enum} level - Log level
   */
  constructor(timestamp, message, attributes = {}, level = constants/* LOG_LEVELS.INFO */.yK.INFO) {
    /** @type {long} */
    this.timestamp = timestamp;
    this.message = message;
    this.attributes = {
      ...attributes,
      pageUrl: (0,clean_url/* cleanURL */.f)('' + runtime/* initialLocation */.FN)
    };
    this.level = level.toUpperCase();
  }
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/logging/shared/utils.js
var utils = __webpack_require__(5235);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/traverse.js
var traverse = __webpack_require__(3403);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/agent-constants.js
var agent_constants = __webpack_require__(6314);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/session/constants.js
var session_constants = __webpack_require__(9181);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/session_replay/constants.js
var session_replay_constants = __webpack_require__(1838);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/feature-gates.js
var feature_gates = __webpack_require__(9334);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/logging/aggregate/index.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */












class Aggregate extends aggregate_base/* AggregateBase */.m {
  static featureName = constants/* FEATURE_NAME */.t9;
  constructor(agentRef) {
    super(agentRef, constants/* FEATURE_NAME */.t9);
    this.isSessionTrackingEnabled = (0,feature_gates/* canEnableSessionTracking */.H)(this.agentIdentifier) && this.agentRef.runtime.session;

    // The SessionEntity class can emit a message indicating the session was cleared and reset (expiry, inactivity). This feature must abort and never resume if that occurs.
    this.ee.on(session_constants/* SESSION_EVENTS.RESET */.wO.RESET, () => {
      this.abort(session_replay_constants/* ABORT_REASONS.RESET */.Mi.RESET);
    });
    this.ee.on(session_constants/* SESSION_EVENTS.UPDATE */.wO.UPDATE, (type, data) => {
      if (this.blocked || type !== session_constants/* SESSION_EVENT_TYPES.CROSS_TAB */.uT.CROSS_TAB) return;
      if (this.loggingMode !== constants/* LOGGING_MODE.OFF */.IG.OFF && data.loggingMode === constants/* LOGGING_MODE.OFF */.IG.OFF) this.abort(session_replay_constants/* ABORT_REASONS.CROSS_TAB */.Mi.CROSS_TAB);else this.loggingMode = data.loggingMode;
    });
    this.harvestOpts.raw = true;
    this.waitForFlags(['log']).then(([loggingMode]) => {
      const session = this.agentRef.runtime.session ?? {};
      if (this.loggingMode === constants/* LOGGING_MODE.OFF */.IG.OFF || session.isNew && loggingMode === constants/* LOGGING_MODE.OFF */.IG.OFF) {
        this.blocked = true;
        this.deregisterDrain();
        return;
      }
      if (session.isNew || !this.isSessionTrackingEnabled) {
        this.updateLoggingMode(loggingMode);
      } else {
        this.loggingMode = session.state.loggingMode;
      }

      /** emitted by instrument class (wrapped loggers) or the api methods directly */
      (0,register_handler/* registerHandler */.X)(constants/* LOGGING_EVENT_EMITTER_CHANNEL */.ve, this.handleLog.bind(this), this.featureName, this.ee);
      this.drain();
      /** harvest immediately once started to purge pre-load logs collected */
      agentRef.runtime.harvester.triggerHarvestFor(this);
    });
  }
  updateLoggingMode(loggingMode) {
    this.loggingMode = loggingMode;
    this.syncWithSessionManager({
      loggingMode: this.loggingMode
    });
  }
  handleLog(timestamp, message, attributes = {}, level = constants/* LOG_LEVELS.INFO */.yK.INFO) {
    if (this.blocked || !this.loggingMode) return;
    if (!attributes || typeof attributes !== 'object') attributes = {};
    if (typeof level === 'string') level = level.toUpperCase();
    if (!(0,utils/* isValidLogLevel */.b)(level)) return (0,console/* warn */.Z)(30, level);
    if (this.loggingMode < (constants/* LOGGING_MODE */.IG[level] || Infinity)) {
      this.reportSupportabilityMetric('Logging/Event/Dropped/Sampling');
      return;
    }
    try {
      if (typeof message !== 'string') {
        const stringified = (0,stringify/* stringify */.P)(message);
        /**
           * Error instances convert to `{}` when stringified
           * Symbol converts to '' when stringified
           * other cases tbd
           * */
        if (!!stringified && stringified !== '{}') message = stringified;else message = String(message);
      }
    } catch (err) {
      (0,console/* warn */.Z)(16, message);
      this.reportSupportabilityMetric('Logging/Event/Dropped/Casting');
      return;
    }
    if (typeof message !== 'string' || !message) return (0,console/* warn */.Z)(32);
    const log = new Log(Math.floor(this.agentRef.runtime.timeKeeper.correctRelativeTimestamp(timestamp)), message, attributes, level);
    const logBytes = log.message.length + (0,stringify/* stringify */.P)(log.attributes).length + log.level.length + 10; // timestamp == 10 chars

    const failToHarvestMessage = 'Logging/Harvest/Failed/Seen';
    if (logBytes > agent_constants/* MAX_PAYLOAD_SIZE */.Y) {
      // cannot possibly send this, even with an empty buffer
      this.reportSupportabilityMetric(failToHarvestMessage, logBytes);
      (0,console/* warn */.Z)(31, log.message.slice(0, 25) + '...');
      return;
    }
    if (this.events.wouldExceedMaxSize(logBytes)) {
      this.reportSupportabilityMetric('Logging/Harvest/Early/Seen', this.events.byteSize() + logBytes);
      this.agentRef.runtime.harvester.triggerHarvestFor(this); // force a harvest synchronously to try adding again
    }
    if (!this.events.add(log)) {
      // still failed after a harvest attempt despite not being too large would mean harvest failed with options.retry
      this.reportSupportabilityMetric(failToHarvestMessage, logBytes);
      (0,console/* warn */.Z)(31, log.message.slice(0, 25) + '...');
    } else {
      this.reportSupportabilityMetric('Logging/Event/Added/Seen');
    }
  }
  serializer(eventBuffer) {
    const sessionEntity = this.agentRef.runtime.session;
    return [{
      common: {
        /** Attributes in the `common` section are added to `all` logs generated in the payload */
        attributes: {
          'entity.guid': this.agentRef.runtime.appMetadata?.agents?.[0]?.entityGuid,
          // browser entity guid as provided from RUM response
          ...(sessionEntity && {
            session: sessionEntity.state.value || '0',
            // The session ID that we generate and keep across page loads
            hasReplay: sessionEntity.state.sessionReplayMode === 1,
            // True if a session replay recording is running
            hasTrace: sessionEntity.state.sessionTraceMode === 1 // True if a session trace recording is running
          }),
          ptid: this.agentRef.runtime.ptid,
          // page trace id
          appId: this.agentRef.info.applicationID,
          // Application ID from info object,
          standalone: Boolean(this.agentRef.info.sa),
          // copy paste (true) vs APM (false)
          agentVersion: this.agentRef.runtime.version,
          // browser agent version
          // The following 3 attributes are evaluated and dropped at ingest processing time and do not get stored on NRDB:
          'instrumentation.provider': 'browser',
          'instrumentation.version': this.agentRef.runtime.version,
          'instrumentation.name': this.agentRef.runtime.loaderType,
          // Custom attributes
          ...this.agentRef.info.jsAttributes
        }
      },
      /** logs section contains individual unique log entries */
      logs: (0,traverse/* applyFnToProps */.R)(eventBuffer, this.obfuscator.obfuscateString.bind(this.obfuscator), 'string')
    }];
  }
  queryStringsBuilder() {
    return {
      browser_monitoring_key: this.agentRef.info.licenseKey
    };
  }

  /** Abort the feature, once aborted it will not resume */
  abort(reason = {}) {
    this.reportSupportabilityMetric("Logging/Abort/".concat(reason.sm));
    this.blocked = true;
    this.events.clear();
    this.events.clearSave();
    this.updateLoggingMode(constants/* LOGGING_MODE.OFF */.IG.OFF);
    this.deregisterDrain();
  }
  syncWithSessionManager(state = {}) {
    if (this.isSessionTrackingEnabled) {
      this.agentRef.runtime.session.write(state);
    }
  }
}

/***/ })

}]);